// extracted by mini-css-extract-plugin
export var alignBaseline = "_q-9";
export var alignCenter = "_q-5";
export var alignFlexEnd = "_q-7";
export var alignFlexStart = "_q-6";
export var alignSelfBaseline = "_q-e";
export var alignSelfCenter = "_q-a";
export var alignSelfFlexEnd = "_q-c";
export var alignSelfFlexStart = "_q-b";
export var alignSelfStretch = "_q-d";
export var alignStretch = "_q-8";
export var column = "_q-2";
export var columnReverse = "_q-4";
export var flex = "_q-0";
export var justifyCenter = "_q-f";
export var justifyFlexEnd = "_q-h";
export var justifyFlexStart = "_q-g";
export var justifySpaceAround = "_q-j";
export var justifySpaceBetween = "_q-i";
export var justifySpaceEvenly = "_q-k";
export var row = "_q-1";
export var rowReverse = "_q-3";
export var wrapNowrap = "_q-m";
export var wrapWrap = "_q-l";
export var wrapWrapReverse = "_q-n";